var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1613"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1090",
    width: 30,
    height: 30,
    rx: 4,
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook-f-brands 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7231 16L19.1675 13.1044H16.3891V11.2253C16.3891 10.4331 16.7772 9.66094 18.0216 9.66094H19.2847V7.19563C19.2847 7.19563 18.1385 7 17.0425 7C14.7544 7 13.2588 8.38688 13.2588 10.8975V13.1044H10.7153V16H13.2588V23H16.3891V16H18.7231Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5397750348cefa64be7b9f10d0da9afc.svg";
export { ForwardRef as ReactComponent };